import angular from 'angular';

FavoritesIndex.$inject = ['localFavorites'];

export function FavoritesIndex(localFavorites) {
    const vm = angular.extend(this, {
        favorites: [],
        selectedCart: {},

        //sort binding
        predicate: 'title',
        reverse: 'true',
        setOrder: setOrder,

        //methods
        showRemovePopover: showRemovePopover,

        //popovers
        buyCartPopover: {},
        removeCartPopover: {},
    });

    initalize();

    function initalize() {
        vm.favorites = localFavorites.getFilteredFavorites();
        setOrder('title');
    }

    function setOrder(predicate) {
        vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
        vm.predicate = predicate;
        vm.caretClass = vm.reverse ? 'icon-caret-down' : 'icon-caret-up';
    }

    function showRemovePopover($event, favlist) {
        // TODO: NEEDS TO SHOW CONFIRMATION POPUP
        localFavorites.deleteFavoriteList(favlist.id);
    }
}
